import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="text-xs font-semibold text-accent-500 uppercase tracking-wider">Categories</span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mt-1 font-heading">
            <strong>漫画分类</strong>
          </h2>
          <p className="text-sm text-foreground-500 mt-2">按类型找到你喜欢的韩国漫画，总有一款适合你</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 bg-background-50 rounded-xl border border-background-200/60 hover:border-primary-200/60 hover:bg-primary-50/30 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 group-hover:bg-primary-100 transition-colors">
                <i className={`${cat.icon} text-xl text-secondary-600 group-hover:text-primary-500 transition-colors`}></i>
              </div>
              <span className="text-sm font-semibold text-foreground-700 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}